import { styled } from "styled-components";

export const ErrorText = styled.p`
  padding: 0 48px;
  color: ${({ theme }) => theme.COLORS.ERROR};
`;
